export const isOutOfLowerRange = (position, valuePosition) => position < valuePosition * -1;
